import React, { Component } from 'react';
import ArrowLeft from '@deliveroo/icon-set/react/ArrowLeft';
import MagnifyingGlass from '@deliveroo/icon-set/react/MagnifyingGlass';
import CrossCircleFill from '@deliveroo/icon-set/react/CrossCircleFill';
import Cross from '@deliveroo/icon-set/react/Cross';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import UnstyledButton from '@deliveroo/consumer-component-library/components/UnstyledButton';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.scss';

class HomeSearch extends Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();

    if (props.returnInputRef && !props.isMobile) {
      props.returnInputRef(this.input);
    }
  }

  componentDidMount() {
    const { isFocused } = this.props;
    if (isFocused) {
      this.input.current.focus();
    }
  }

  handleOnKeyDown = (event) => {
    const { handleOnKeyDown } = this.props;
    if (handleOnKeyDown) {
      handleOnKeyDown(event, this.input);
    }
  };

  renderSearchBox = () => {
    const {
      onChange,
      value,
      handleOnClear,
      handleOnClick,
      isModalSearch,
      isMobile,
      handleOnClose,
      handleOnSubmit,
      searchPlaceholder,
    } = this.props;

    const inputClasses = classnames(styles.searchInput, {
      [styles.searchInputModal]: isModalSearch,
    });

    const searchInput = (
      <form
        className={styles.searchForm}
        action="."
        onSubmit={(event) => {
          event.preventDefault();
          handleOnSubmit(event);
        }}
      >
        <input
          type="search"
          className={inputClasses}
          name="home-search"
          placeholder={searchPlaceholder}
          onChange={onChange}
          value={value}
          autoComplete="off"
          ref={this.input}
          onKeyDown={this.handleOnKeyDown}
          disabled={isMobile ? 'disabled' : undefined}
          onClick={!isMobile ? handleOnClick : undefined}
          spellCheck={false}
        />
      </form>
    );

    return (
      <div className={styles.inputWrapper}>
        {isModalSearch && (
          <UnstyledButton onClick={handleOnClose}>
            <Icon component={ArrowLeft} color="teal" size={24} />
          </UnstyledButton>
        )}
        {!isModalSearch && (
          <div className={styles.contentBefore}>
            <Icon component={MagnifyingGlass} color="light-grey" size={18} />
          </div>
        )}
        {searchInput}
        {isMobile && (
          <button type="button" className={styles.searchButton} onClick={handleOnClick} />
        )}
        {handleOnClear &&
          value && (
            <button type="button" className={styles.clearButton} onClick={handleOnClear}>
              <Icon component={isModalSearch ? CrossCircleFill : Cross} color="light-grey" />
            </button>
          )}
      </div>
    );
  };

  render() {
    const { children, isModalSearch } = this.props;

    const wrapperClasses = classnames(styles.wrapper, {
      [styles.wrapperModal]: isModalSearch,
    });

    return (
      <div className={wrapperClasses}>
        <div className={styles.search}>{this.renderSearchBox()}</div>
        {children && <div className={styles.results}>{children}</div>}
      </div>
    );
  }
}

HomeSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  handleOnClear: PropTypes.func,
  handleOnClick: PropTypes.func,
  children: PropTypes.node,
  isFocused: PropTypes.bool,
  isModalSearch: PropTypes.bool,
  isMobile: PropTypes.bool,
  handleOnKeyDown: PropTypes.func,
  returnInputRef: PropTypes.func,
  handleOnClose: PropTypes.func,
  handleOnSubmit: PropTypes.func,
  searchPlaceholder: PropTypes.string.isRequired,
};

HomeSearch.defaultProps = {
  handleOnClear: undefined,
  children: null,
  handleOnClick: undefined,
  isFocused: false,
  isModalSearch: false,
  isMobile: false,
  handleOnKeyDown: undefined,
  returnInputRef: undefined,
  handleOnClose: undefined,
  handleOnSubmit: undefined,
};

export default HomeSearch;
